namespace GeniuzPOS.InventoryReport {
    export interface IcReport02Form {
    }

    export class IcReport02Form extends Serenity.PrefixedContext {
        static formKey = 'InventoryReport.IcReport02';
    }
}
